<template>
    <div class="text-right">
        <div class="text-caption text-secondary-light text-size-xs">{{ t('orderReceipt.totalPrice') }}</div>
        <div data-id="orderHistoryItemPrice" class="text-h3 font-weight-bold text-secondary-dark text-size-lg">
            {{ formatKr(price) }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { IOrderHistoryCardPrice } from '../../types';
import { formatKr } from '@/helpers';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps<IOrderHistoryCardPrice>();
</script>
